import { Link as ReactRouterLink, useInRouterContext, type LinkProps } from "react-router";

/**
 * 兼容页面单独嵌入和完整路由两种运行方式。
 * 生产路由内使用 React Router Link；单元测试或外部嵌入缺少 Router 时退化为普通锚点。
 */
export function RouterLink(props: LinkProps) {
    const inRouter = useInRouterContext();
    if (!inRouter) {
        const href = typeof props.to === "string" ? props.to : props.to.pathname || "";
        return <a {...props} href={href} />;
    }
    return <ReactRouterLink {...props} />;
}

export default RouterLink;
